var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBitcoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 24,
    viewBox: "0 0 36 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.99585,
    width: 35.004,
    height: 24,
    rx: 4,
    fill: "#2D2C2C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5629 11.9999C26.5629 16.4538 22.952 20.0645 18.4977 20.0645C14.0435 20.0645 10.4326 16.4538 10.4326 11.9999C10.4326 7.54594 14.0435 3.9353 18.4977 3.9353C22.952 3.9353 26.5629 7.54594 26.5629 11.9999ZM20.4354 9.00361C21.5572 9.38884 22.3779 9.96568 22.2169 11.0392C22.1 11.8253 21.6625 12.2054 21.0814 12.3386C21.8787 12.752 22.1505 13.5367 21.898 14.4856C21.4185 15.851 20.2789 15.966 18.7632 15.6806L18.3951 17.1484L17.5066 16.9275L17.8696 15.4794C17.6392 15.4224 17.4038 15.3614 17.1613 15.2964L16.7968 16.7515L15.9093 16.5307L16.2769 15.0599L14.4872 14.6101L14.9287 13.5966C14.9287 13.5966 15.5838 13.7696 15.5747 13.757C15.8263 13.819 15.9382 13.6556 15.9822 13.5472L16.9796 9.5633C16.9907 9.37523 16.9254 9.13824 16.5654 9.04849C16.5791 9.03891 15.92 8.88865 15.92 8.88865L16.1564 7.94323L17.9486 8.38543L18.3131 6.93124L19.2011 7.15209L18.8442 8.57754C19.0831 8.63149 19.3231 8.68645 19.5565 8.74444L19.9109 7.32807L20.7994 7.54892L20.4354 9.00361ZM18.3094 11.4296C18.9146 11.5901 20.2316 11.9393 20.4612 11.0237C20.6954 10.087 19.4159 9.80412 18.7894 9.6656L18.7893 9.6656L18.7893 9.66559C18.7183 9.6499 18.6558 9.63606 18.6047 9.62333L18.1622 11.3914C18.2043 11.4018 18.2537 11.4149 18.3091 11.4295L18.3094 11.4296L18.3094 11.4296ZM17.6236 14.2759C18.3486 14.4668 19.934 14.8845 20.1863 13.8756C20.4445 12.8441 18.9073 12.5006 18.1573 12.3329L18.1572 12.3329C18.0734 12.3142 17.9995 12.2977 17.9389 12.2826L17.4509 14.2312C17.5005 14.2434 17.5585 14.2587 17.6235 14.2758L17.6236 14.2759Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitcoin);
export default __webpack_public_path__ + "static/media/bitcoin.7b3bfb05cefe1ed3f7c7e46b30ceb7b4.svg";
export { ForwardRef as ReactComponent };